import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import { linkResolver } from "../../utilities/linkResolver";
import { useAuth } from "../../context/AuthContext";

const LanguageSwitcher = ({ pageData }) => {
  const [isFirstLinkActive, setIsFirstLinkActive] = useState(false);
  const [isSecondLinkActive, setIsSecondLinkActive] = useState(true);
  const { setCurrentLanguage } = useAuth();
  const { localizations, locale } = pageData;

  let localizationsData = {
    ...localizations?.data[0]?.attributes,
    internal: { type: pageData?.internal?.type },
  };
  // console.log(linkResolver(localizationsData));

  useEffect(() => {
    setCurrentLanguage(locale);
  }, [pageData, locale, setCurrentLanguage]);

  return (
    <div className="switch-container btn-brown d-flex">
      <Link
        to={`${linkResolver(localizationsData)}`}
        className={`${
          localizationsData?.locale
            ? `switch-${localizationsData?.locale?.split("-")[0]}`
            : ""
        } ${isFirstLinkActive ? "active-lang" : ""}`}
        onClick={() => {
          setIsFirstLinkActive(true);
          setIsSecondLinkActive(false);
        }}
      >
        {localizationsData?.locale
          ? `${localizationsData?.locale?.split("-")[0]}`
          : ""}
      </Link>

      <p className="mb-0 text-white"> &nbsp;/&nbsp; </p>

      <Link
        to={linkResolver(pageData)}
        className={`${locale ? `switch-${locale.split("-")[0]}` : ""} ${
          isSecondLinkActive ? "active-lang" : ""
        }`}
        onClick={() => {
          setIsSecondLinkActive(true);
          setIsFirstLinkActive(false);
        }}
      >
        {locale ? locale.split("-")[0] : ""}
      </Link>
    </div>
  );
};

export default LanguageSwitcher;
